import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { setAuthToken } from "../functions";
import { useMsal } from "@azure/msal-react";

export function useAuthInfo() {
  const { instance } = useMsal();
  const [currentToken, setCurrentToken] = useState(
    localStorage.getItem("jwtToken"),
  );
  useEffect(() => {
    window.addEventListener("storage", () => {
      const token = localStorage.getItem("jwtToken");
      setCurrentToken(token);
      if (!token) {
        // Clear any stale MSAL interaction lock before logout to avoid interaction_in_progress error
        Object.keys(sessionStorage)
          .filter((k) => k.includes("interaction.status"))
          .forEach((k) => sessionStorage.removeItem(k));
        instance.logoutRedirect().catch(() => {});
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (currentToken) {
    var decodedToken = jwt_decode(currentToken);
    var decoded = decodedToken;
    setAuthToken(currentToken);
  }
  return decoded;
}
